import styled from 'styled-components';
import TextField from '@mui/material/TextField';

export const Wrapper = styled.div`
    background: white;
    width: 416px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: 24px;
    border-radius: 4px;

    & h1 {
        font-weight: 500;
        line-height: 24px;
        font-size: 20px;
        margin-top: 0;
        margin-bottom: 16px;
    }
`;

export const StyledTextField = styled(TextField)`
    width: 100%;
`;
